import { render, staticRenderFns } from "./samplingCustom.vue?vue&type=template&id=7f2c87d6&scoped=true&"
import script from "./samplingCustom.vue?vue&type=script&lang=js&"
export * from "./samplingCustom.vue?vue&type=script&lang=js&"
import style0 from "./samplingCustom.vue?vue&type=style&index=0&id=7f2c87d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2c87d6",
  null
  
)

component.options.__file = "samplingCustom.vue"
export default component.exports